import * as React from 'react';
import { FilterRow } from '@/components/custom/filter';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { SearchIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

const FilterInput = React.forwardRef(({ label, startIcon: StartIcon, endIcon: EndIcon, type, id, fullWidth, wrapperClassName, ...props }, ref) => {
  const compId = React.useId();
  const isSearchType = type === 'search';
  const IconToRender = EndIcon || (isSearchType && !StartIcon ? SearchIcon : null);
  const hasEndIcon = !!IconToRender;

  return (
    <FilterRow
      ref={ref}
      className={cn(fullWidth ? 'md:w-full' : null, wrapperClassName)}
    >
      {label && <Label htmlFor={id ?? compId}>{label}</Label>}
      <div className="relative">
        {StartIcon && (
          <div className="pointer-events-none absolute inset-y-0 start-0 flex items-center justify-center ps-3 text-neutral peer-disabled:opacity-50 [&_svg]:size-4">
            <StartIcon aria-hidden="true" />
          </div>
        )}
        <Input
          id={id ?? compId}
          className="peer"
          type={type}
          startIcon={!!StartIcon}
          endIcon={hasEndIcon}
          {...props}
        />
        {hasEndIcon && (
          <div className="pointer-events-none absolute inset-y-0 end-0 flex items-center justify-center pe-3 text-neutral peer-disabled:opacity-50 [&_svg]:size-4">
            <IconToRender aria-hidden="true" />
          </div>
        )}
      </div>
    </FilterRow>
  );
});
FilterInput.displayName = 'FilterInput';

export { FilterInput };
